export const privacyOptions = {
    1: {value: 1, label: 'visible to everyone'},
    2: {value: 2, label: 'visible to members only'}
};

export const joinPolicyOptions = {
    1: {value: 1, label: 'anyone can join'},
    2: {value: 2, label: 'join requests require approval'},
    3: {value: 3, label: 'only admins can add members'}
};
